module.exports = __webpack_public_path__ + "static/img/p2.ecee2ff7.png";